"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToUTCString = void 0;
/**
 * Convert date at 00:00:00.000 UTC and ISO format
 * @public
 *
 * @param date - A valid Date object
 * @param removeZeroUTC - Remove zone designator for zero UTC offset
 *
 * @returns Date string with ISO format at 00:00:00.000 UTC
 *
 * @example
 * ```ts
 * const utcString = dateToUTCString(new Date('11/25/2021'))
 * console.log(utcString);
 * // -> '2021-11-25T22:42:36.000'
 * ```
 */
function dateToUTCString(date, removeZeroUTC = true) {
    const stringValue = new Date(date.toUTCString()).toISOString();
    return removeZeroUTC ? stringValue.slice(0, -1) : stringValue;
}
exports.dateToUTCString = dateToUTCString;
//# sourceMappingURL=date-to-UTC-string.js.map